import { Caption } from '@casavo/base-ui'
import { motion } from 'framer-motion'
import React, { ReactElement, useState } from 'react'

import { useDevice } from '@/context/Device'

import { tooltipBox, tooltipTriangle, tooltipWrapper } from './style.css'

export type Props = {
  borderRadius?: number
  color?: string
  fontSize?: number
  isNearLeftBorder?: boolean
  isNearRightBorder?: boolean
  padding?: number
  text: string | ReactElement
  tooltipWidth?: number
  triangleHeight?: number
}

const Tooltip: React.FC<Props> = ({ children, text }) => {
  const [isActive, setIsActive] = useState(false)
  const device = useDevice()

  const tooltipAnimation = {
    hover: {
      opacity: 1,
      transition: {
        opacity: {
          duration: 0.2,
        },
        y: {
          duration: 0.3,
        },
      },
      y: -2,
    },
    initial: {
      opacity: 0,
      transition: {
        opacity: {
          delay: 0.3,
          duration: 0,
        },
        y: {
          duration: 0.3,
        },
      },
      y: 0,
    },
  }

  return (
    <motion.div
      animate={isActive ? 'hover' : 'initial'}
      className={tooltipWrapper}
      onClick={(e) => {
        setIsActive(!isActive)
        e.preventDefault()
        e.stopPropagation()
      }}
      onHoverEnd={() => setIsActive(false)}
      onHoverStart={() => setIsActive(true)}
      onMouseOutCapture={() => device === 'mobile' && setIsActive(false)}
    >
      <motion.div className={tooltipBox} variants={tooltipAnimation}>
        <Caption color="white">{text}</Caption>
        <span className={tooltipTriangle} />
      </motion.div>
      {children}
    </motion.div>
  )
}

export default Tooltip
